import {Link} from 'react-router-dom';
import React from 'react';

import {useracc, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import './css/advertise.css';

export default class Advertise extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			show: 'advertise',
      name: '',
			email: '',
			message: '',
		};
		this.handleChange = this.handleChange.bind(this);
		this.processDetails = this.processDetails.bind(this);
  };

  
  
  async componentDidMount() {
		document.title = "Advertise - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
		this.setState({status: true});
	}

	componentWillUnmount() {
	}

	handleChange(event) {
		//var isChecked = event.target.checked;
		var item = event.target.value;
		if( event.target.name === "name" ) this.setState({name:item});
		if( event.target.name === "email" ) this.setState({email:item});
		if( event.target.name === "message" ) this.setState({message:item});
	}

	async processDetails(event) {
		event.preventDefault();
		this.setState({show: 'complete'});

		const params = new URLSearchParams();
		params.append('name', this.state.name);
		params.append('email', this.state.email);
		params.append('message', this.state.message);

		await putApi('/api/v2/advertise', params);

	}
	

	render() {
		
		return (
			<>
				{this.state.status &&
					<>
						<div className="advertise">
							<div className="advertise-background"></div>
						</div>
						

						
						{/*<div className="website-background"></div>*/}
						<div className="article">

							<Row className="gx-0">
								<Col className="advertise-header">
									<h1>Advertise</h1>
								</Col>
							</Row>

							<Row className="gx-0">
								<Col md={{span: 6, offset: 2}} >
								
									<h3>Advertise with Mix365</h3>
									
									Radio is a great way to advertise to a wide audience. Mix365 can offer custom made packages at very competitive rates starting at just £8 per month. It needn’t cost the earth to get your message heard around the world on both of our stations.<br />
									From special events to taxi companies, takeaways to luxury hotels. We have an advertising solution for you and your business. Contact Mix365 today to discuss your requirements and we can build a professional on air advertising campaign to suit your needs.<br /><br />

									If you would like to advertise on a banner on our website we have a limited amount of space for ad banners like the example below. Our dedicated design team can design you a bespoke advert banner at a reasonable rate. If you’re interested in finding out more about how to advertise with us, please use the form below to get in touch or email sales@mix365.co.uk Our sales team will be more than happy to help you.<br /><br />

									<img src="/images/advertise.png" alt="Advertise your business" width="60%" />
								</Col>

							</Row>


							<Row className="py-5">
								<Col className="text-center">
								
									<ul className="home-followus">
										<li>
											<a href="https://www.facebook.com/groups/mix365" title="Facebook" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" /> Facebook
											</a>
										</li>
										<li>
											<a href="https://www.instagram.com/mix365radio/" title="Instagram" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" /> Instagram
											</a>
										</li>
										<li>
											<a href="https://twitter.com/Mix365R" title="Twitter" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'twitter']} className="header-socials" /> Twitter
											</a>
										</li>
										<li>
											<a href="https://discord.gg/DtRYeVPJ5J" title="Discord" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'discord']} className="header-socials" /> Discord
											</a>
										</li>
									</ul>

								</Col>
							</Row>
						</div>
					</>
				}
			</>
		);
	}
}
